import {Route} from '@angular/router';
// AUTENTICACIÓN
import {LoginComponent} from './autenticacion/login/login.component';
import {RecuperarClaveComponent} from './autenticacion/recuperarClave/recuperar-clave.component';
// MENÚ Y TEMPLATE
import {LayoutComponent} from './layout/layout.component';
import {BienvenidoComponent} from './layout/content/home/bienvenido/bienvenido.component';
import {MiperfilComponent} from './layout/content/perfil/miperfil/miperfil.component';
import {LockComponent} from './autenticacion/lockScreen/lock.component';
import {AuthGuard} from './autenticacion/servicios/auth-guard.service';
import {ListUsuarioComponent} from './layout/content/seguridad/usuario/cmp-list-usuario/list-usuario.component';
import {FormUsuarioComponent} from './layout/content/seguridad/usuario/cmp-form-usuario/form-usuario.component';
import {FormEmisorComponent} from './layout/content/seguridad/emisor/cmp-form-emisor/form-emisor.component';
import {FormAuditoriaComponent} from './layout/content/seguridad/auditoria/cmp-form-auditoria/form-auditoria.component';
import {ListAuditoriaComponent} from './layout/content/seguridad/auditoria/cmp-list-auditoria/list-auditoria.component';
import {FormRolComponent} from './layout/content/seguridad/roles/cmp-form-roles/form-roles.component';
import {ListRolesComponent} from './layout/content/seguridad/roles/cmp-list-roles/list-roles.component';
import {ListEmisorComponent} from './layout/content/seguridad/emisor/cmp-list-emisor/list-emisor.component';
import {LogSunatComponent} from './layout/content/transaccion/logSunat/list-logSunat.component';
import {GeneralComponent} from './layout/content/reporte/general/general.component';
import {IndicadoresComponent} from './layout/content/reporte/dashboard/indicadores/indicadores.component';
import {
    ListLogNoTransformadosComponent
} from './layout/content/transaccion/logNoTranformados/list-logNoTransformados.component';
import {PortalConsultaComponent} from './layout/content/transaccion/portalConsulta/portalConsulta.component';
import {IndicadoresGestionComponent} from './layout/content/reporte/dashboard/gestion/gestion.component';
import {LogRecibidoComponent} from './layout/content/transaccion/logRecibidos/list-logRecibido.component';
import {NotaCreditoComponent} from './layout/content/emisorFacturas/notaCredito/nota-credito.component';
import {ResetClaveComponent} from './autenticacion/resetClave/reset-clave.component';
import {
    FormConfiguracionComponent
} from './layout/content/seguridad/configuracion/cmp-form-configuracion/form-configuracion.component';
import {EmisorFacturasComponent} from './layout/content/emisorFacturas/emisorFacturas/emisor-facturas.component';
import {LogEmisorTmpComponent} from './layout/content/transaccion/logEmisorTmp/list-logEmisorTmp.component';
import {RegistroVentaComponent} from './layout/content/reporte/registroVenta/registroVenta.component';
import {
    ListEmisorTercerosComponent
} from './layout/content/transaccion/emisorTerceros/cmp-list-emisorTerceros/list-emisorTerceros.component';
import {
    FormEmisorTercerosComponent
} from './layout/content/transaccion/emisorTerceros/cmp-form-emisorTerceros/form-emisorTerceros.component';
import {
    ListDocumentsComponent
} from './layout/content/transaccion/emisorTerceros/cmp-list-documents/listDocuments.component';
import {
    ListDetalleLoteComponent
} from './layout/content/transaccion/emisorTerceros/cmp-list-detalle-lote/list-detalle-lote.component';
import {AzureLoginComponent} from './autenticacion/azureLogin/azureLogin.component';
import {VerifyAzureLoginComponent} from './autenticacion/verifyAzureLogin/verifyAzureLogin.component';
import {LogEmisorHistoryComponent} from "./layout/content/transaccion/logEmisorHistory/list-logEmisorHistory.component";
import {LogSFTPComponent} from "./layout/content/transaccion/logSFTP/list-logSFTP.component";

// RUTAS EXTERNAS
export const MODULE_ROUTES: Route[] = [
    {path: 'loginAzure', component: AzureLoginComponent},
    {path: 'verifyAzureLogin', component: VerifyAzureLoginComponent},
    {path: 'login', component: LoginComponent},
    {path: 'lock', component: LockComponent},
    {path: 'recuperarClave', component: RecuperarClaveComponent},
    {path: 'resetClave', component: ResetClaveComponent},
    {path: '', component: LoginComponent},
    {
        path: 'content', component: LayoutComponent,
        children: [
            // BASE APP
            {path: '', redirectTo: 'home', pathMatch: 'full'},
            {path: 'home', component: BienvenidoComponent, outlet: 'second'},
            {path: 'miPerfil', component: MiperfilComponent, outlet: 'second'},
            {path: 'detallePerfil', component: FormUsuarioComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'perfilCustomer', component: FormEmisorComponent, outlet: 'second', canActivate: [AuthGuard]},

            /*** MODULO DE APLICATIVOS ***/
            // MÓDULO DE USUARIO
            // MÓDULO DE USUARIO
            {path: 'usuario', component: ListUsuarioComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'usuario/create', component: FormUsuarioComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'usuario/:id', component: FormUsuarioComponent, outlet: 'second', canActivate: [AuthGuard]},


            // MODULO FACTURADOR
            {path: 'facturador', component: EmisorFacturasComponent, outlet: 'second', canActivate: [AuthGuard]},

            // MÓDULO EMISOR
            {path: 'emisor', component: ListEmisorComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'emisor/create', component: FormEmisorComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'emisor/:id', component: FormEmisorComponent, outlet: 'second', canActivate: [AuthGuard]},

            // MÓDULO ROLES
            {path: 'roles', component: ListRolesComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'roles/create', component: FormRolComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'roles/:accion/:id', component: FormRolComponent, outlet: 'second', canActivate: [AuthGuard]},

            // MÓDULO CONFIGURACIÓN
            {
                path: 'configuracion/create',
                component: FormConfiguracionComponent,
                outlet: 'second',
                canActivate: [AuthGuard]
            },

            // MÓDULO DE AUDITORÍA
            {path: 'auditoria', component: ListAuditoriaComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'auditoria/create', component: FormAuditoriaComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'auditoria/:id', component: FormAuditoriaComponent, outlet: 'second', canActivate: [AuthGuard]},

            // MODULO DE TRANSACCIONES
            {path: 'logEmisorHistory', component: LogEmisorHistoryComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'logEmisor', component: LogEmisorTmpComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'logEmisorV2', component: LogEmisorTmpComponent, outlet: 'second', canActivate: [AuthGuard]},
            {
                path: 'logNoTransformados',
                component: ListLogNoTransformadosComponent,
                outlet: 'second',
                canActivate: [AuthGuard]
            },
            {path: 'logSunat', component: LogSunatComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'Recibidos', component: LogRecibidoComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'logSFTP', component: LogSFTPComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'emisorFacturas', component: NotaCreditoComponent, outlet: 'second', canActivate: [AuthGuard]},

            // MODULO DE REPORTES
            {path: 'reporte', component: GeneralComponent, outlet: 'second', canActivate: [AuthGuard]},

            // DASHBOARD INDICADORES
            {path: 'operativos', component: IndicadoresComponent, outlet: 'second', canActivate: [AuthGuard]},
            {path: 'gestion', component: IndicadoresGestionComponent, outlet: 'second', canActivate: [AuthGuard]},

            // DASHBOARD INDICADORES
            {path: 'registroVentas', component: RegistroVentaComponent, outlet: 'second', canActivate: [AuthGuard]},

            // EMISOR A TERCEROS
            {path: 'configThrids', component: ListEmisorTercerosComponent, outlet: 'second', canActivate: [AuthGuard]},
            {
                path: 'configThrids/:id',
                component: FormEmisorTercerosComponent,
                outlet: 'second',
                canActivate: [AuthGuard]
            },
            {
                path: 'listDocumentThrids/ELECTRONIC',
                component: ListDocumentsComponent,
                outlet: 'second',
                canActivate: [AuthGuard]
            },
            {
                path: 'listDocumentThrids/ELECTRONIC/:id',
                component: ListDetalleLoteComponent,
                outlet: 'second',
                canActivate: [AuthGuard]
            },
            {
                path: 'listDocumentThrids/PHYSICAL',
                component: ListDocumentsComponent,
                outlet: 'second',
                canActivate: [AuthGuard]
            },
            {
                path: 'listDocumentThrids/PHYSICAL/:id',
                component: ListDetalleLoteComponent,
                outlet: 'second',
                canActivate: [AuthGuard]
            },
        ]
    },

    /*** MODULO PORTAL CLIENTES ***/
    {path: 'portalConsultaDoc', redirectTo: 'login'},
    {path: 'portalConsultaDoc/:key', component: PortalConsultaComponent}
];




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/app.routing.ts